import * as React from 'react';
// PLOP: Imports
const CenterListing = React.lazy(() => import(/* webpackChunkName: "CentreListing" */ '@/components/organisms/CentreListing/CentreListing'));
const Team = React.lazy(() => import(/* webpackChunkName: "Team" */ '@/components/organisms/Team/Team'));
const ContactForm = React.lazy(() => import(/* webpackChunkName: "ContactForm" */ '@/components/organisms/ContactForm/ContactForm'));
const CorporateHeader = React.lazy(() => import(/* webpackChunkName: "CorporateHeader" */ '@/components/organisms/CorporateHeader/CorporateHeader'));
const HotspotBlock = React.lazy(() => import(/* webpackChunkName: "HotspotBlock" */ '@/components/organisms/HotspotBlock/HotspotBlock'));
const HotspotMapBlock = React.lazy(() => import(/* webpackChunkName: "HotspotBlock" */ '@/components/organisms/HotspotMapBlock/HotspotMapBlock'));
const ContactHero = React.lazy(() => import(/* webpackChunkName: "ContactHero" */ '@/components/organisms/ContactHero/ContactHero'));
const InspirationFeature = React.lazy(() => import(/* webpackChunkName: "InspirationFeature" */ '@/components/organisms/InspirationFeature/InspirationFeature'));
const ProductCardCarousel = React.lazy(() => import(
/* webpackChunkName: "ProductCardCarousel" */ '@/components/organisms/ProductCardCarousel/ProductCardCarousel'));
const OfferCardCarousel = React.lazy(() => import(/* webpackChunkName: "OfferCardCarousel" */ '@/components/organisms/OfferCardCarousel/OfferCardCarousel'));
const ArticleCardCarousel = React.lazy(() => import(
/* webpackChunkName: "ArticleCardCarousel" */ '@/components/organisms/ArticleCardCarousel/ArticleCardCarousel'));
const ImageLinkBlocks = React.lazy(() => import(/* webpackChunkName: "ImageLinkBlocks" */ '@/components/organisms/ImageLinkBlocks/ImageLinkBlocks'));
const WhatsOnHero = React.lazy(() => import(/* webpackChunkName: "WhatsOnHero" */ '@/components/organisms/WhatsOnHero/WhatsOnHero'));
const FeaturedArticleOverview = React.lazy(() => import(
/* webpackChunkName: "FeaturedArticleOverview" */ '@/components/organisms/FeaturedArticleOverview/FeaturedArticleOverview'));
const EventEndedNotificationBanner = React.lazy(() => import(
/* webpackChunkName: "EventEndedNotificationBanner" */ '@/components/organisms/EventEndedNotificationBanner/EventEndedNotificationBanner'));
const AnchorNav = React.lazy(() => import(/* webpackChunkName: "AnchorNav" */ '@/components/organisms/AnchorNav/AnchorNav'));
const CentreOverview = React.lazy(() => import(/* webpackChunkName: "CentreOverview" */ '@/components/organisms/CentreOverview/CentreOverview'));
const ServiceFeature = React.lazy(() => import(/* webpackChunkName: "ServiceFeature" */ '@/components/organisms/ServiceFeature/ServiceFeature'));
const AccordionBlock = React.lazy(() => import(/* webpackChunkName: "AccordionBlock" */ '@/components/organisms/AccordionBlock/AccordionBlock'));
const MappedInMapLargeBlock = React.lazy(() => import(/* webpackChunkName: "MappedInLargeMap" */ '@/components/organisms/MappedInLargeMap/MappedInLargeMap'));
const OfferListingHero = React.lazy(() => import(/* webpackChunkName: "OfferListingHero" */ '@/components/organisms/OfferListingHero/OfferListingHero'));
const OfferListingHeroNoIntro = React.lazy(() => import(
/* webpackChunkName: "OfferListingHeroNoIntro" */ '@/components/organisms/OfferListingHeroNoIntro/OfferListingHeroNoIntro'));
const OffersBlock = React.lazy(() => import(/* webpackChunkName: "OffersBlock" */ '@/components/organisms/OffersBlock/OffersBlock'));
const FoodAndBeverageHero = React.lazy(() => import(
/* webpackChunkName: "FoodAndBeverageHero" */ '@/components/organisms/FoodAndBeverageHero/FoodAndBeverageHero'));
const FoodAndBeverageListingHero = React.lazy(() => import(
/* webpackChunkName: "FoodAndBeverageListingHero" */ '@/components/organisms/FoodAndBeverageListingHero/FoodAndBeverageListingHero'));
const OfferDetailHero = React.lazy(() => import(/* webpackChunkName: "OfferDetailHero" */ '@/components/organisms/OfferDetailHero/OfferDetailHero'));
const BrandHero = React.lazy(() => import(/* webpackChunkName: "BrandHero" */ '@/components/organisms/BrandHero/BrandHero'));
const CorporateBrandHero = React.lazy(() => import(/* webpackChunkName: "CorporateBrandHero" */ '@/components/organisms/CorporateBrandHero/CorporateBrandHero'));
const DestinationGuideHero = React.lazy(() => import(
/* webpackChunkName: "DestinationGuideHero" */ '@/components/organisms/DestinationGuideHero/DestinationGuideHero'));
const EventHero = React.lazy(() => import(/* webpackChunkName: "EventHero" */ '@/components/organisms/EventHero/EventHero'));
const MappedInMap = React.lazy(() => import(/* webpackChunkName: "MappedInMap" */ '@/components/organisms/MappedInMap/MappedInMap'));
const ImageAndLinksCta = React.lazy(() => import(/* webpackChunkName: "ImageAndLinksCta" */ '@/components/organisms/ImageAndLinksCta/ImageAndLinksCta'));
const CtaBanner = React.lazy(() => import(/* webpackChunkName: "CtaBanner" */ '@/components/organisms/CtaBanner/CtaBanner'));
const FeaturedStores = React.lazy(() => import(/* webpackChunkName: "FeaturedStores" */ '@/components/organisms/FeaturedStores/FeaturedStores'));
const Footer = React.lazy(() => import(/* webpackChunkName: "Footer" */ '@/components/organisms/Footer/Footer'));
const Header = React.lazy(() => import(/* webpackChunkName: "Header" */ '@/components/organisms/Header/Header'));
const FullWidthMedia = React.lazy(() => import(/* webpackChunkName: "FullWidthMedia" */ '@/components/organisms/FullWidthMedia/FullWidthMedia'));
const BrandCardList = React.lazy(() => import(/* webpackChunkName: "BrandCardList" */ '@/components/organisms/BrandCardList/BrandCardList'));
const BrandListing = React.lazy(() => import(/* webpackChunkName: "BrandListing" */ '@/components/organisms/BrandListing/BrandListing'));
const ListingHero = React.lazy(() => import(/* webpackChunkName: "ListingHero" */ '@/components/organisms/ListingHero/ListingHero'));
const FoodAndBeverageCardList = React.lazy(() => import(
/* webpackChunkName: "FoodAndBeverageCardList" */ '@/components/organisms/FoodAndBeverageCardList/FoodAndBeverageCardList'));
const FoodAndBeverageListing = React.lazy(() => import(
/* webpackChunkName: "FoodAndBeverageListing" */ '@/components/organisms/FoodAndBeverageListing/FoodAndBeverageListing'));
const SegmentedServiceFeature = React.lazy(() => import(
/* webpackChunkName: "SegmentedServiceFeature" */ '@/components/organisms/SegmentedServiceFeature/SegmentedServiceFeature'));
const SplitContent = React.lazy(() => import(/* webpackChunkName: "SplitContent" */ '@/components/organisms/SplitContent/SplitContent'));
const SpotlightCarousel = React.lazy(() => import(/* webpackChunkName: "SpotlightCarousel" */ '@/components/organisms/SpotlightCarousel/SpotlightCarousel'));
const CardList = React.lazy(() => import(/* webpackChunkName: "CardList" */ '@/components/organisms/CardList/CardList'));
const RichText = React.lazy(() => import(/* webpackChunkName: "RichText" */ '@/components/organisms/RichText/RichText'));
const NotificationToast = React.lazy(() => import(/* webpackChunkName: "NotificationToast" */ '@/components/molecules/NotificationToast/NotificationToast'));
const AddEventToCalendarFeature = React.lazy(() => import(
/* webpackChunkName: "AddEventToCalendarFeature" */ '@/components/organisms/AddEventToCalendarFeature/AddEventToCalendarFeature'));
const SimpleHero = React.lazy(() => import(/* webpackChunkName: "SimpleHero" */ '@/components/organisms/SimpleHero/SimpleHero'));
const VisitHero = React.lazy(() => import(/* webpackChunkName: "VisitHero" */ '@/components/organisms/VisitHero/VisitHero'));
const WindowHero = React.lazy(() => import(/* webpackChunkName: "WindowHero" */ '@/components/organisms/WindowHero/WindowHero'));
const WindowHeroHomepage = React.lazy(() => import(/* webpackChunkName: "WindowHeroHomepage" */ '@/components/organisms/WindowHeroHomepage/WindowHeroHomepage'));
const WhatsOnListing = React.lazy(() => import(/* webpackChunkName: "WhatsOnListing" */ '@/components/organisms/WhatsOnListing/WhatsOnListing'));
const OfferListing = React.lazy(() => import(/* webpackChunkName: "OfferListing" */ '@/components/organisms/OfferListing/OfferListing'));
const MapGoogle = React.lazy(() => import(/* webpackChunkName: "MapGoogle" */ '@/components/organisms/MapGoogle/MapGoogle'));
const BlockSearch = React.lazy(() => import(/* webpackChunkName: "BlockSearch" */ '@/components/organisms/BlockSearch/BlockSearch'));
const BrandTicker = React.lazy(() => import(/* webpackChunkName: "BrandTicker" */ '@/components/organisms/BrandTicker/BrandTicker'));
const OpeningTimes = React.lazy(() => import(/* webpackChunkName: "OpeningTimes" */ '@/components/organisms/OpeningTimes/OpeningTimes'));
const HomepageHero = React.lazy(() => import(/* webpackChunkName: "HomepageHero" */ '@/components/organisms/HomepageHero/HomepageHero'));
const QuoteBlock = React.lazy(() => import(/* webpackChunkName: "QuoteBlock" */ '@/components/organisms/QuoteBlock/QuoteBlock'));
const SearchListing = React.lazy(() => import(/* webpackChunkName: "SearchListing" */ '@/components/organisms/SearchListing/SearchListing'));
const SavedItemsList = React.lazy(() => import(/* webpackChunkName: "SavedItemsList" */ '@/components/organisms/SavedItemsList/SavedItemsList'));
const ArticleHero = React.lazy(() => import(/* webpackChunkName: "ArticleHero" */ '@/components/organisms/ArticleHero/ArticleHero'));
const InformationWidget = React.lazy(() => import(/* webpackChunkName: "InformationWidget" */ '@/components/organisms/InformationWidget/InformationWidget'));
const StickySplitContent = React.lazy(() => import(/* webpackChunkName: "StickySplitContent" */ '@/components/organisms/StickySplitContent/StickySplitContent'));
const SplitMultiImage = React.lazy(() => import(/* webpackChunkName: "SplitMultiImage" */ '@/components/organisms/SplitMultiImage/SplitMultiImage'));
const OffsetCard = React.lazy(() => import(/* webpackChunkName: "OffsetCard" */ '@/components/organisms/OffsetCard/OffsetCard'));
const FeatureBlocks = React.lazy(() => import(/* webpackChunkName: "FeatureBlocks" */ '@/components/organisms/FeatureBlocks/FeatureBlocks'));
const VideoHeroBlock = React.lazy(() => import(/* webpackChunkName: "VideoHeroBlock" */ '@/components/organisms/VideoHeroBlock/VideoHeroBlock'));
const ScrollingSplitContent = React.lazy(() => import(
/* webpackChunkName: "ScrollingSplitContent" */ '@/components/organisms/ScrollingSplitContent/ScrollingSplitContent'));
const StatBlock = React.lazy(() => import(/* webpackChunkName: "StatBlock" */ '@/components/organisms/StatBlock/StatBlock'));
const Timeline = React.lazy(() => import(/* webpackChunkName: "Timeline" */ '@/components/organisms/Timeline/Timeline'));
const FullWidthHero = React.lazy(() => import(/* webpackChunkName: "FullWidthHero" */ '@/components/organisms/FullWidthHero/FullWidthHero'));
export default {
    // PLOP: Exports
    CenterListing,
    CorporateHeader,
    FeatureBlocks,
    StickySplitContent,
    ScrollingSplitContent,
    StatBlock,
    Timeline,
    WhatsOnHero,
    InformationWidget,
    EventEndedNotificationBanner,
    AccordionBlock,
    AnchorNav,
    BrandCardList,
    BrandHero,
    BrandListing,
    CardList,
    CentreOverview,
    CorporateBrandHero,
    CtaBanner,
    DestinationGuideHero,
    EventHero,
    FeaturedStores,
    FoodAndBeverageCardList,
    FoodAndBeverageHero,
    FoodAndBeverageListing,
    FoodAndBeverageListingHero,
    Footer,
    FullWidthMedia,
    Header,
    HotspotMapBlock,
    ImageAndLinksCta,
    ListingHero,
    MappedInMap,
    MappedInMapLargeBlock,
    OfferDetailHero,
    OfferListing,
    OfferListingHero,
    OfferListingHeroNoIntro,
    OffersBlock,
    RichText,
    NotificationToast,
    AddEventToCalendarFeature,
    SimpleHero,
    SegmentedServiceFeature,
    SplitMultiImage,
    SplitContent,
    SpotlightCarousel,
    VisitHero,
    WindowHero,
    WindowHeroHomepage,
    OffersOverview: OfferListingHero,
    ServiceFeature,
    MapGoogle,
    BrandTicker,
    SearchBlock: BlockSearch,
    SearchListing,
    OpeningTimesBlock: OpeningTimes,
    HomepageHero,
    QuoteBlock,
    WhatsOnListing,
    SavedItemsList,
    FeaturedArticleOverview,
    ArticleHero,
    ArticleCardCarousel,
    ImageLinkBlocks,
    CardOffers: OfferCardCarousel,
    InspirationFeature,
    OffsetCard,
    ContactForm,
    HotspotBlock,
    ProductList: ProductCardCarousel,
    ContactHero,
    Team,
    VideoHeroBlock,
    FullWidthHero,
};
